/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Bodyfat_TitleInputs */

const en_us2_profile_bodyfat_title = /** @type {(inputs: Profile_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body fat`)
};

const pt_br2_profile_bodyfat_title = /** @type {(inputs: Profile_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentual de gordura`)
};

const es_419_profile_bodyfat_title = /** @type {(inputs: Profile_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grasa corporal`)
};

const pt_pt2_profile_bodyfat_title = /** @type {(inputs: Profile_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentagem de gordura`)
};

const fr_fr2_profile_bodyfat_title = /** @type {(inputs: Profile_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse grasse`)
};

const de_de2_profile_bodyfat_title = /** @type {(inputs: Profile_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körperfett`)
};

const it_it2_profile_bodyfat_title = /** @type {(inputs: Profile_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grasso corporeo`)
};

/**
* | output |
* | --- |
* | "Body fat" |
*
* @param {Profile_Bodyfat_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_bodyfat_title = /** @type {((inputs?: Profile_Bodyfat_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Bodyfat_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_bodyfat_title(inputs)
	if (locale === "es-419") return es_419_profile_bodyfat_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_bodyfat_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_bodyfat_title(inputs)
	if (locale === "de-DE") return de_de2_profile_bodyfat_title(inputs)
	if (locale === "it-IT") return it_it2_profile_bodyfat_title(inputs)
	return en_us2_profile_bodyfat_title(inputs)
});
export { profile_bodyfat_title as "profile.bodyfat_title" }